var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.5C22.5 15.3438 21.8125 16 21 16C20.1562 16 19.5 15.3438 19.5 14.5C19.5 13.6875 20.1562 13 21 13C21.8125 13 22.5 13.6875 22.5 14.5ZM20.75 24V28C20.75 28.5625 20.2812 29 19.75 29C19.1875 29 18.75 28.5625 18.75 28V21.0312L17.8438 22.5312C17.5625 23 16.9375 23.1562 16.4688 22.875C16 22.5938 15.8438 21.9688 16.125 21.5L17.9375 18.4688C18.5 17.5625 19.4688 17 20.5312 17H21.4375C22.5 17 23.4688 17.5625 24.0312 18.4688L25.8438 21.5C26.125 21.9688 25.9688 22.5938 25.5 22.875C25.0312 23.1562 24.4062 23 24.125 22.5312L23.25 21.0312V28C23.25 28.5625 22.7812 29 22.25 29C21.6875 29 21.25 28.5625 21.25 28V24H20.75Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPerson);
export default __webpack_public_path__ + "static/media/filledPerson.1d85c5eea448c19f9e34b1e90a7035e2.svg";
export { ForwardRef as ReactComponent };